import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import SmartBanner from 'react-smartbanner';
import Bowser from 'bowser';
import { Loading, I18N, GlobalContext } from 'commons';
import { orgId } from 'utils';
import { getParam } from '../../utils/ebUtils';
import Banner from './Banner';
import Nav from './Nav';
import Language from './Language';
import Footer from './Footer';
import { translationType } from 'constants/applicationConstant';
import 'react-smartbanner/dist/main.css';

const Home = ({
  '*': path,
  children,
}) => {
  const {
    account: { id: accountId, name: accountName },
    navConfig: {
      showSignUp,
      showCrisisTask,
      showCrisisSingleEventDashboard,
      showNotification,
      showWeather,
      showIncidents,
      showEvent,
      showOverview,
      showFAQs,
      showOnCallSchedule,
      showDirectoryChat
    },
    organization: { orgName, isPublic, isRecipientExist, memberApp, translation }
  } = useContext(GlobalContext);

  const uaParser = Bowser.getParser(navigator.userAgent);
  const platformType = uaParser.getPlatformType(true);
  const isMobileDevice = platformType === 'mobile' || platformType === 'tablet';
  const osName = uaParser.getOSName(true);

  const bannerAppMeta = {
    ios: 'apple-itunes-everbridge-app',
    android: 'google-play-app'
  };

  return (
    <div id="resetFocus" tabIndex={-1}>
      <a href="#main_content" className="sr-only sr-only-focusable">
        <I18N>global.skip.to.main.content</I18N>
      </a>
      <Loading type="ajax" />
      {
        isRecipientExist && isMobileDevice && memberApp && getParam('from') !== 'member' &&
                <SmartBanner
                  title="Everbridge"
                  author="Everbridge, Inc."
                  force={osName}
                  daysHidden={0}
                  daysReminder={0}
                  position="top"
                  appMeta={bannerAppMeta}
                />
      }
      <Banner />
      <Nav
        {...{
          path,
          accountId,
          accountName,
          showLogin: !!orgName,
          showSignUp,
          showCrisisTask,
          showCrisisSingleEventDashboard,
          showOnCallSchedule,
          showNotification,
          showWeather,
          showEvent,
          showIncidents,
          showOverview,
          showFAQs,
          showDirectoryChat
        }}
      />
      {translationType.NONE !== translation.type &&  <Language />}
      <main id="main_content" tabIndex="-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

Home.propTypes = {
  '*': PropTypes.string,
  children: PropTypes.node,
};

Home.defaultProps = {
  '*': '',
  children: null,
};

export default Home;
